<template>
    <c-modal
            v-model="model"
            confirmLabel="Text Payment Link"
            cancel-label="Cancel"
            centered size="md"
            title="Confirm phone number to text"
            :tag="false"
            :progressing="loading"
            @hide="hide"
            @submit="submit"
            @show="shown"
    >
        <b-alert :show="errors.any()" variant="danger" class="px-4">
            <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{err}}</li>
            </ul>
        </b-alert>
        <div class="text-center mb-2">
            Ask customer to pay as soon as they receive the payment link.
        </div>
        <div>
            <b-input-group :prepend="'Phone Number'">
                <b-input-group-append>
                    <b-input-group-text class="bg-white" :class="'border-left-0'">
                        +1
                    </b-input-group-text>
                </b-input-group-append>
                <b-input v-model="phoneNumber" v-mask="'###-###-####'" :decimal="false" :name="'Phone Number'" v-validate="`required`"/>
            </b-input-group>
        </div>
    </c-modal>
</template>

<script>
    import CModal from "../../shared/Cmodal";
    export default {
        name: "confirmMobile",
        components: {CModal},
        props: {
            value: {required: true, type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            mobile: {type: [String, null, Number], default: ''},
            order: {type: [Object, null], default: {}}
        },
        data () {
          return {
              phoneNumber: this.mobile
          }
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            shown () {
                this.phoneNumber = this.mobile
            },
            hide () {
                this.model = false
            },
            submit () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        
                        const model = {...this.order}
                        model.phoneNumber = this.phoneNumber
                        if (this.order.orderType === 1) {
                            this.$emit('createLinkPickup', model)
                        } else if (this.order.orderType === 2) {
                            this.$emit('createLinkDineIn', model)
                        } else if (this.order.orderType === 3) {
                            this.$emit('createLinkDelivery', model)
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
